import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
/** Geometry of `logo.svg`: 10 squares in 4 diagonals fanning out from the top-left corner. */ const LOGO_SQUARES = [
    {
        x: 0.53125,
        y: 0.53125,
        width: 4.62462,
        height: 4.62462,
        diagonal: 0,
        opacity: 1
    },
    {
        x: 0.59375,
        y: 6.14062,
        width: 4.36036,
        height: 4.36036,
        diagonal: 1,
        opacity: 0.77
    },
    {
        x: 6.14062,
        y: 0.59375,
        width: 4.36036,
        height: 4.36036,
        diagonal: 1,
        opacity: 0.77
    },
    {
        x: 0.789062,
        y: 11.8281,
        width: 4.03003,
        height: 4.03003,
        diagonal: 2,
        opacity: 0.44
    },
    {
        x: 11.8281,
        y: 0.789062,
        width: 4.03003,
        height: 4.03003,
        diagonal: 2,
        opacity: 0.44
    },
    {
        x: 6.27344,
        y: 6.27344,
        width: 4.0961,
        height: 4.0961,
        diagonal: 2,
        opacity: 0.44
    },
    {
        x: 0.859375,
        y: 17.3125,
        width: 3.83183,
        height: 3.83183,
        diagonal: 3,
        opacity: 0.22
    },
    {
        x: 17.375,
        y: 0.859375,
        width: 3.83183,
        height: 3.83183,
        diagonal: 3,
        opacity: 0.22
    },
    {
        x: 11.8281,
        y: 6.40625,
        width: 3.8979,
        height: 3.76577,
        diagonal: 3,
        opacity: 0.22
    },
    {
        x: 6.40625,
        y: 11.8281,
        width: 3.76577,
        height: 3.8979,
        diagonal: 3,
        opacity: 0.22
    }
];
const DIAGONAL_DELAY_SECONDS = 0.18;
/** Page loading state: the BLIKS logo builds itself diagonal by diagonal; the label is for screen readers only. */ function BliksLoader({ label }) {
    return /*#__PURE__*/ _jsxs("div", {
        role: "status",
        className: "flex flex-col items-center",
        children: [
            /*#__PURE__*/ _jsx("svg", {
                width: "64",
                height: "64",
                viewBox: "0 0 22 22",
                "aria-hidden": "true",
                className: "text-bliks-logo",
                children: LOGO_SQUARES.map((square)=>/*#__PURE__*/ _jsx("rect", {
                        x: square.x,
                        y: square.y,
                        width: square.width,
                        height: square.height,
                        rx: 0.264264,
                        fill: "currentColor",
                        opacity: square.opacity,
                        className: "origin-center animate-bliks-logo-build transform-fill motion-reduce:animate-none",
                        style: {
                            // The keyframes fade each square in to its own logo opacity.
                            "--logo-square-opacity": square.opacity,
                            animationDelay: `${square.diagonal * DIAGONAL_DELAY_SECONDS}s`
                        }
                    }, `${square.x}-${square.y}`))
            }),
            /*#__PURE__*/ _jsx("span", {
                className: "sr-only",
                children: label
            })
        ]
    });
}
export { BliksLoader };

//# sourceMappingURL=bliks-loader.js.map